"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIconNameForItem = exports.DestinationTypeIcon = exports.getHotelObjectIdFromTravelDestination = exports.getShortInformation = void 0;
const graphql_types_1 = require("@hotelplan/graphql.types");
const getShortInformation = (t, items, limit) => {
    const currentLimit = limit ? limit : 2;
    return items.length > currentLimit
        ? t('search:destination.count', { count: items.length })
        : items.map(item => item.name).join(', ');
};
exports.getShortInformation = getShortInformation;
const getHotelObjectIdFromTravelDestination = (destinationsState) => {
    if (!destinationsState || !destinationsState.destinations)
        return;
    const hotel = destinationsState.destinations.find(destination => destination.type === graphql_types_1.TravelDestinationType.Hotel);
    return hotel ? hotel.id : undefined;
};
exports.getHotelObjectIdFromTravelDestination = getHotelObjectIdFromTravelDestination;
var DestinationTypeIcon;
(function (DestinationTypeIcon) {
    DestinationTypeIcon["HOTEL"] = "hotel";
    DestinationTypeIcon["FLIGHT"] = "flug";
    DestinationTypeIcon["THEME"] = "themes";
    DestinationTypeIcon["GEO"] = "planet";
    DestinationTypeIcon["AIRPORT"] = "airport";
    DestinationTypeIcon["ROUNDTRIP"] = "rundreisen";
    DestinationTypeIcon["CRUISE"] = "cruise";
})(DestinationTypeIcon || (exports.DestinationTypeIcon = DestinationTypeIcon = {}));
function getIconNameForItem(item) {
    switch (item.type) {
        case graphql_types_1.TravelDestinationType.Hotel:
            return DestinationTypeIcon.HOTEL;
        case graphql_types_1.TravelDestinationType.Airport:
            return DestinationTypeIcon.FLIGHT;
        case graphql_types_1.TravelDestinationType.Theme:
            return DestinationTypeIcon.THEME;
        case graphql_types_1.TravelDestinationType.AirportGroup:
            return DestinationTypeIcon.AIRPORT;
        case graphql_types_1.TravelDestinationType.Roundtrip:
            return DestinationTypeIcon.ROUNDTRIP;
        case graphql_types_1.TravelDestinationType.Cruise:
            return DestinationTypeIcon.CRUISE;
        default:
            return DestinationTypeIcon.GEO;
    }
}
exports.getIconNameForItem = getIconNameForItem;
//# sourceMappingURL=TravelDestionation.utils.js.map